var lib_core = require("lib-core");
var moment = require("moment");

var VersionsView = function(model, stateMachine, sidebarView, parentView, configuration) {
    var self = this;

    this.model = model;
    this.stateMachine = stateMachine;
    this.sidebarView = sidebarView;
    this.parentView = parentView;
    this.configuration = configuration;

    this.setupVersionMessage();
    this.setupSidebar();

    if(this.parentView.model.wizardMode()) {
        this.hide();
    } else {
        this.show();
    }

    this.parentView.model.wizardMode.onChange(this, function(mode) {
        if(!mode) {
            self.show();
        }
    });

    window.beforeUnloadListener = window.addEventListener("beforeunload", function (e) {
        if (self.model.dataRoot.hasUnsavedChanges){
            var confirmationMessage = 'Unsaved changed will be lost. Are you sure you want to exit?';
            (e || window.event).returnValue = confirmationMessage;
            return confirmationMessage;
        }
    });
};

VersionsView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.parentView.getTopNav().addVersion();
    }
    return this._template;
};

VersionsView.prototype.getSidebar = function () {
    if (!this._sideTemplate) {
        this._sideTemplate = this.sidebarView && this.sidebarView.getTemplate().addVersions();
    }
    return this._sideTemplate;
};

VersionsView.prototype.getConnectionMenu = function () {
    if (!this._versionMessageTemplate) {
        this._versionMessageTemplate = this.connectionView.getTemplate();
    }
    return this._versionMessageTemplate;
};

VersionsView.prototype.setupVersionMessage = function() {
    var self = this;

    this.versionTemplate = this.getTemplate();
    
    //content
    var updateMessage = function(hasChanged) {
        if(self.model.asset() && self.model.asset().getLastVersion()) {
            if(hasChanged) {
                self.versionTemplate.setVersionButton("Unsaved", "draft");
                //self.versionTemplate.setVersionMessage("Version " + self.model.asset().getLastVersion().name.toString().toLowerCase() + " + changes");
            } else {
                self.versionTemplate.setVersionButton("Version " + self.model.asset().getLastVersion().name.toString().toLowerCase(), "version");
                self.versionTemplate.setVersionMessage("");
            }
        } else {
            self.versionTemplate.setVersionButton("Unsaved");
            self.versionTemplate.setVersionMessage("");
        }
    };
    self.model.dataRoot.onChangeSaveState("updateVersionButton",function(val){
        updateMessage(val);
    });

    self.model.asset.onChange({}, function(){
        updateMessage(self.model.dataRoot.hasUnsavedChanges);
    });
    updateMessage(self.model.dataRoot.hasUnsavedChanges);

    //click action
    this.versionTemplate.$el.on("Cioui:VersionMessage:click", function() {
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.TOGGLE_SIDEBAR);
        self.stateMachine.handle(cEvent);
    });
};

VersionsView.prototype.setupSidebar = function() {
    var self = this;
    this.sidebar = this.getSidebar();

    if(!this.sidebar) return;

    //connect close button
    this.sidebar.$el.on('Cioui:VersionsSidebar:Close', function(event){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.TOGGLE_SIDEBAR);
        self.stateMachine.handle(cEvent);
    });

    // Add draft box top
    this.draftItem = this.sidebar.addDraftItem();
    this.draftItem.$el.on('Cioui:VersionsSidebarItem:createButtonClicked', function(e, e2, name, description) {
        var cEvent = null;

        if(self.configuration && !self.configuration.preCheckBeforeVersionCreation) {
            cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CREATE_VERSION_VERSIONSIDEBAR);
        } else {
            cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.PRECHECK_BEFORE_VERSION_CREATION);
        }

        cEvent.data('name', name);
        cEvent.data('description', description);
        self.stateMachine.handle(cEvent);
    });
    this.draftItem.$el.on('Cioui:VersionsSidebarItem:draftButtonClicked', function(e, e2, name, description) {
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.TOGGLE_DRAFT_VERSIONSIDEBAR);
        self.stateMachine.handle(cEvent);
    });
    this.draftItem.setNoNewChanges();
    this.draftItem.hideDraftCreation();
    this.draftItem.hideBusy();

    this.versionItems = [];
    var updateMessage = function(val) {
        self.versionItems.forEach(function(item) { item.remove();});
        var versions = self.model.asset().getVersions();
        var reversed_versions = [].concat(versions).reverse();
        reversed_versions.forEach(function(version) {
            var item = self.sidebar.addVersionItem(version.name, version.description, moment(version.time).format('MMMM DD, YYYY'));
            self.versionItems.push(item);
        });

        if(val) {
            self.draftItem.setDraftVersion(versions.length, versions.length+1);
        }else{
            self.draftItem.setNoNewChanges();
        }
    }
    //observe model for content (create new version)

    self.model.dataRoot.onChangeSaveState("updateVersionMessage", function(val) {
        updateMessage(val);
    }, 0);

    self.model.asset.onChange({}, function() {
        updateMessage(self.model.dataRoot.hasUnsavedChanges);
    }, 0);

    updateMessage(self.model.dataRoot.hasUnsavedChanges);

    this.model.draftVisible.onChange({}, function() {
        if(self.model.draftVisible()){
            self.draftItem.showDraftCreation();
        }else{
            self.draftItem.hideDraftCreation();
        }
    }, 10);

    this.model.busy.onChange({}, function() {
        if(self.model.busy()){
            self.draftItem.showBusy();
        }else{
            self.draftItem.hideBusy();
        }
    }, 10);
};

VersionsView.prototype.hide = function() {
    if(this.versionTemplate) this.versionTemplate.hide();
};

VersionsView.prototype.show = function() {
    if(this.versionTemplate) this.versionTemplate.show();
};

module.exports = VersionsView;
